<template>
  <vx-card>
    <div class="mb-base mt-4 vx-row justify-between items-top">
      <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
        <span class="text-black text-2xl">Setting Icon Root</span>
      </section>
    </div>
    <main>
      <vs-tabs>
        <vs-tab :label="'Ketegori ZIS'">
          <div class="tab-text mt-2">
            <tabel-content :jenis="1"></tabel-content>
          </div>
        </vs-tab>
        <vs-tab :label="'Ketegori Campaign'">
          <div class="tab-text mt-2">
            <tabel-content :jenis="2"></tabel-content>
          </div>
        </vs-tab>
        <vs-tab :label="'Ketegori SOS'">
          <div class="tab-text mt-2">
            <tabel-content :jenis="3"></tabel-content>
          </div>
        </vs-tab>
      </vs-tabs>
    </main>
  </vx-card>
</template>

<script>
import TabelContent from "@/views/iconRoot/component/TableContent.vue";

const transactionType = [
  {
    id: 1,
    text: "Data Pengeluaran",
  },
  {
    id: 0,
    text: "Data Pemasukan",
  },
];

export default {
  components: {
    TabelContent,
  },
  data() {
    return {
      jenis: 1,
      jenisList: [],
      typeSelect: transactionType[1],
      mitra_id: null,
      transactionType,
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
